// URS-F412: helper compartido para clasificar codigos de visita.
// Consumido por CostesPanel (por-estudio) y Estadisticas (agregado global)
// para evitar que las reglas diverjan si cambian en el futuro.
//
// Reglas (mantener en sincronia con backend/routes/statistics_routes.py):
//   - EA (Eventos Adversos) → NUNCA cuenta (ni con toggle ON).
//   - VAL, V0, VALORACION, SEG, SCR, EVAL → intermedias (solo con toggle ON).
//   - Codigos con "MIN" (T30MIN, T7D30MIN...) → intermedias.
//   - Codigos con "H<24" (T4H, T12H)         → intermedias.
//   - Codigos con "H>=24" (T24H, T48H)        → siempre cuentan.
//   - Codigos de dias (T0, T7D, T14D, T30D)   → siempre cuentan.

export const ALWAYS_EXCLUDED_CODES = ['EA'];
export const INTERMEDIATE_ADMIN_CODES = ['VAL', 'VALORACION', 'V0', 'SEG', 'SCR', 'EVAL'];

const _H_RE = /(\d+)\s*H(?!D)/;

export function isAlwaysExcluded(code) {
  return ALWAYS_EXCLUDED_CODES.includes(String(code || '').toUpperCase().trim());
}

export function isIntermediateVisit(code) {
  const c = String(code || '').toUpperCase().trim();
  if (!c) return true;
  if (INTERMEDIATE_ADMIN_CODES.includes(c)) return true;
  if (c.includes('MIN')) return true;
  const m = c.match(_H_RE);
  if (m) {
    const hours = parseInt(m[1], 10);
    if (!Number.isNaN(hours) && hours < 24) return true;
  }
  return false;
}

// Combinada: dice si el codigo cuenta con la configuracion actual.
export function isComputableVisit(code, includeIntermediate) {
  if (isAlwaysExcluded(code)) return false;
  if (includeIntermediate) return true;
  return !isIntermediateVisit(code);
}

// Clave numerica de orden por tiempo (para renderizar breakdowns).
//   VAL / V0 → -1        (antes que T0)
//   EA / SEG / SCR / EVAL → 10000 (al final)
//   T0, T7D, T14D...     → numero embebido
export function visitTimeKey(code) {
  const c = String(code || '').toUpperCase().trim();
  if (['VAL', 'V0', 'VALORACION'].includes(c)) return -1;
  if (['EA', 'SEG', 'SCR', 'EVAL'].includes(c)) return 10000;
  const m = c.match(/(\d+)/);
  return m ? parseInt(m[1], 10) : 5000;
}
